import React from "react";
import { TruckIcon, HeadphonesIcon, LeafIcon, GemIcon, BoxIcon } from "lucide-react";
interface TrustItem {
  icon: BoxIcon;
  title: string;
  detail: string;
}
const items: TrustItem[] = [{
  icon: TruckIcon,
  title: 'Free Shipping in NY',
  detail: 'Complimentary USPS delivery on orders over $150 USD.'
}, {
  icon: HeadphonesIcon,
  title: 'Customer Service',
  detail: 'Personal styling assistance on WhatsApp, every day.'
}, {
  icon: LeafIcon,
  title: 'Sustainability',
  detail: 'Responsibly sourced gold and plastic-free packaging.'
}, {
  icon: GemIcon,
  title: 'Superior Materials',
  detail: 'Solid 18K Gold and 18K Italian Gold. Never plated.'
}];
export function TrustBar() {
  return <section aria-label="Why shop with ELORA" className="w-full border-y border-line bg-ivory py-12 md:py-14" data-id="element-161" data-mp="1lxik86nzyyok">
      <ul className="mx-auto grid max-w-editorial gap-8 px-6 sm:grid-cols-2 md:px-12 lg:grid-cols-4 lg:gap-10 lg:px-20" data-id="element-162" data-mp="5j0hfg7zhwkf">
        {items.map(({
        icon: Icon,
        title,
        detail
      }) => <li key={title} className="flex flex-col items-center text-center" data-id="element-163" data-mp="1ajyk3qpgrnbp">
            <Icon className="h-6 w-6 text-gold" strokeWidth={1.2} data-id="element-164" data-mp="16htr8u6uauq4" />
            <h3 className="mt-4 font-sans text-[11px] uppercase tracking-luxe text-maroon" data-id="element-165" data-mp="16joe4e1o8wwu">
              {title}
            </h3>
            <p className="mt-2 max-w-[15rem] font-sans text-[12.5px] font-light leading-relaxed text-maroon-mute" data-id="element-166" data-mp="1fhgw5pys2inx">
              {detail}
            </p>
          </li>)}
      </ul>
    </section>;
}